import { getContainerStyles, getPointerStyles } from '../../getPointerStyles';
import { pointerSvgUrl } from '../../pointerSvgUrl';
export var tooltipContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'none',
      position: 'absolute',
      maxWidth: v.maxWidth,
      zIndex: v.zIndex
    }, p.pointing && Object.assign({
      pointerEvents: 'all'
    }, getContainerStyles({
      placement: p.basePlacement,
      padding: v.pointerMargin
    })), p.open && {
      display: 'block'
    });
  },
  pointer: function pointer(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables,
        rtl = _ref2.rtl;
    return Object.assign({
      display: 'block',
      position: 'absolute',
      width: v.pointerWidth,
      height: v.pointerHeight
    }, getPointerStyles({
      backgroundColor: v.backgroundColor,
      borderSize: v.borderSize,
      borderColor: 'transparent',
      gap: v.pointerGap,
      padding: v.pointerMargin,
      height: v.pointerHeight,
      width: v.pointerWidth,
      placement: p.basePlacement,
      rtl: rtl,
      svg: pointerSvgUrl(v.backgroundColor)
    }));
  },
  content: function content(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return Object.assign({
      display: 'block',
      padding: v.padding,
      textAlign: 'left',
      color: v.color,
      background: v.backgroundColor,
      borderRadius: v.borderRadius,
      boxShadow: v.boxShadow
    }, p.pointing && {
      pointerEvents: 'all'
    });
  }
};
//# sourceMappingURL=tooltipContentStyles.js.map
